import React, { useContext } from "react";
import { FilterContext } from "../../context/Filter";

const SubscriptionDetailstb = ({ data = [] }) => {

    const { open, setOpen } = useContext(FilterContext)
    return (
        <div className={`bg-white ${open ? "w-[1000px] " : "w - [1200px]"} rounded-lg shadow shadow p-2 border max-w-[1200px] w-full`}>
            <h2 className="text-xl font-bold text-gray-800 mb-4">
                Subscription Details
            </h2>

            <div className="overflow-x-auto max-h-[300px]">
                <table className="w-full">
                    <thead>
                        <tr className="bg-[#1467B3] text-white">
                            <th className="px-4 py-3 text-left font-semibold">#</th>
                            <th className="px-4 py-3 text-left font-semibold whitespace-nowrap">
                                Vehicle ID
                            </th>
                            <th className="px-4 py-3 text-left font-semibold">LOB</th>
                            <th className="px-4 py-3 text-left font-semibold">PPL</th>
                            <th className="px-4 py-3 text-left font-semibold">PL</th>
                            <th className="px-4 py-3 text-left font-semibold whitespace-nowrap">
                                Subscription type
                            </th>
                            <th className="px-4 py-3 text-left font-semibold whitespace-nowrap">
                                Created Date
                            </th>
                            <th className="px-4 py-3 text-left font-semibold whitespace-nowrap">
                                Expiry Date
                            </th>
                            <th className="px-4 py-3 text-left font-semibold whitespace-nowrap">
                                Product Code
                            </th>
                            <th className="px-4 py-3 text-left font-semibold">Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.length > 0 ? (
                            data.map((row, index) => (
                                <tr
                                    key={index}
                                    className={index % 2 === 0 ? "bg-gray-50" : "bg-white"}
                                >
                                    <td className="px-4 py-3 text-gray-700">{index + 1}</td>
                                    <td className="px-4 py-3 text-gray-700">{row["Vehicle Id"]}</td>
                                    <td className="px-4 py-3 text-gray-700">{row.LOB}</td>
                                    <td className="px-4 py-3 text-gray-700">{row.PPL}</td>
                                    <td className="px-4 py-3 text-gray-700">{row.PL}</td>
                                    <td className="px-4 py-3 text-gray-700">{row["Subscription type"]}</td>
                                    <td className="px-4 py-3 text-gray-700">{row["Created Date"]}</td>
                                    <td className="px-4 py-3 text-gray-700">{row["Expiry Date"]}</td>
                                    <td className="px-4 py-3 text-gray-700">{row["Product Code"]}</td>
                                    <td className="px-4 py-3 text-gray-900 font-semibold">
                                        {row.Amount}
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td
                                    colSpan="10"
                                    className="text-center py-4 text-gray-500"
                                >
                                    No subscription data available
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default SubscriptionDetailstb;
